import React, { useState, useLayoutEffect } from "react";
import Default from "./Default/index";
import MandG from "./MandG/index";
import { custom2 } from "../../../Utils/static-strings";
const FutureMain = (props) => {
  const [skin, setSkin] = useState(null);

  useLayoutEffect(() => {
    if (props.skin) {
      setSkin(props.skin);
    }
  }, []);

  const handleSkinSwitch = () => {
    if (
      sessionStorage.getItem("skinName")?.toLowerCase() ===
      custom2?.toLowerCase()
    ) {
      return <MandG {...props} />;
    } else {
      return <Default {...props} />;
    }
  };

  return <React.Fragment>{skin !== null && handleSkinSwitch()}</React.Fragment>;
};

export default FutureMain;
